import * as json2csv from "json2csv";
export { default as Request } from "./request";
export { default as CoinHelper } from "./coin";
import config from "@/config.json";
import JSZip from "jszip";
import { project } from "@/config.json";
import {
  DATE_TABLE_FORMAT,
  DATE_ABLE_FORMAT_DAY,
  DATE_FORMAT_ACCURATE_TO_DAY,
  DATE_CHART_FORMAT,
} from "@/models";
import moment from "moment";
(window as any).project = project;

export const random = (len: number) => {
  const dict = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let str = "";
  for (let i = 0; i < len; i += 1) {
    str += dict[Math.floor(Math.random() * dict.length)];
  }
  return str;
};

export const dataURItoBlob = (dataURI) => {
  var binary = atob(dataURI.split(",")[1]);
  var array: number[] = [];
  for (var i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
};

export const decimalRegex = /^\d+\.\d{0,2}$/;
export const numberRegex = /^\d+?/;
export const numberAndDecimalRgex = /^\d+(\.\d{1,3})?$/;

/**
 *
 * @param filename 文件名
 * @param fields 表头
 * @param json 数据源
 */
export const export2csv = (filename: string, fields: string[], json: Object) => {
  const opts = { fields };
  console.log(opts);
  const csv = json2csv.parse(json, opts);

  const downloadLink = document.createElement("a");
  downloadLink.textContent = "";
  downloadLink.download = filename + ".csv";
  downloadLink.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const export2zip = async (filename: string, fields: Object, json: Object) => {
  // const opts = { fields };
  const zip = new JSZip();

  for (let i in fields) {
    const opts = { fields: fields[i] };
    zip.file(i + ".csv", json2csv.parse(json[i], opts));
  }

  const zipFile = await zip.generateAsync({ type: "blob" });

  var downloadLink = document.createElement("a");
  var blob = new Blob([zipFile]);
  var url = URL.createObjectURL(blob);
  downloadLink.href = url;
  downloadLink.download = filename + ".zip";

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const powerUnit2object = (value: number | string) =>
  +value >= 1000
    ? {
        value: (+value / 1000).toFixed(2),
        unit: "PH/s",
      }
    : {
        value: (+value).toFixed(2),
        unit: "TH/s",
      };

export const powerUnit2jsonLTC = (value: string | number) => {
  const power = value ? +value : 0;
  if (power >= 10e5) {
    return {
      value: (power / 10e5).toFixed(2),
      unit: "TH/s",
    };
  } else if (power >= 10e2) {
    return {
      value: (power / 10e2).toFixed(2),
      unit: "GH/s",
    };
  } else if (power > 0) {
    return {
      value: power.toFixed(2),
      unit: "MH/s",
    };
  } else {
    return {
      value: 0,
      unit: "MH/s",
    };
  }
};

export const powerUnitObject = (value: number | string, coin: string = "BSV") => {
  return coin != "LTC" ? powerUnit2object(value) : powerUnit2jsonLTC(value);
};

export const CoinGroup = (coin: string) => {
  return coin != "LTC" ? ["BTC", "BSV"] : ["LTC", "DOGE"];
};

// 状态，0 待处理，1 为审核通过，9 为支付完成, -1 为拒绝转账, -2 提交底层失败 , -7 预扣款生效失败， -8 为预扣款
export const withDrawStatus = {
  "-1": { text: "IndexPage.withdraw.NoPassed", style: "color-red" },
  "-2": { text: "IndexPage.withdraw.Processing", style: "color-blue" },
  "0": { text: "IndexPage.withdraw.Processing", style: "color-blue" },
  "1": { text: "IndexPage.withdraw.Processing", style: "color-blue" },
  "9": { text: "IndexPage.withdraw.Paid", style: "color-green" },
  "-7": { text: "IndexPage.withdraw.NoPassed", style: "color-red" },
  "-8": { text: "IndexPage.withdraw.Processing", style: "color-blue" },
};
// 状态，0 为待处理，-1 为取消兑换，-2 为兑换失败，1 为有效订单，2 为开始下单，3 为已成功发送兑换请求，4 为成功兑换，开始给用户加钱，9 为兑换成功，已经给用户加了钱
export const changeStatus = {
  "-2": { text: "IndexPage.exchange.NoChange", style: "color-red" },
  "-1": { text: "IndexPage.exchange.NoChange", style: "color-red" },
  "0": { text: "IndexPage.exchange.InExchange", style: "color-blue" },
  "1": { text: "IndexPage.exchange.InExchange", style: "color-blue" },
  "2": { text: "IndexPage.exchange.InExchange", style: "color-blue" },
  "3": { text: "IndexPage.exchange.InExchange", style: "color-blue" },
  "4": { text: "IndexPage.exchange.InExchange", style: "color-blue" },
  "9": { text: "IndexPage.exchange.Exchanged", style: "color-green" },
};

// 个人在资金池余额变动状态 2.注资 3.套现 4.支付PPS 5.出块-块奖励（FPPS）8.出块-块奖励(BTC转换成BCH) 19待汇总金额  (资金池无4)
export const userAmountStatus = {
  "2": "greenText",
  "3": "redText",
  "4": "redText",
  "5": "greenText",
  "8": "greenText",
  "11": "redText",
  "19": "redText",
  "30": "greenText",
};
// 资金池变动类型
export const chgTypeJson = {
  "1": "treasury.HandleFee",
  "2": "treasury.Deposit",
  "3": "treasury.Withdrawal",
  "4": "treasury.PaymentFPPS",
  "5": "treasury.BlockReward",
  "6": "treasury.ColdWallet",
  "7": "treasury.HotWallet",
  "8": "treasury.BlockReward",
  "9": "treasury.BlockReward",
  "21": "treasury.FundsFallback",
  "11": "treasury.PaymentFPPS",
  "19": "treasury.PayingFPPS",
  "10": "treasury.PaymentBTC",
  "30": "treasury.LockReward",
};

export const isExternalLinks = !!location.pathname.match(/sub\/\w+/gim);
export const matchExternalLinks = () => {
  const array = location.href.match(/sub\/(\w+)/im);
  if (array) {
    return array[1];
  } else {
    return "";
  }
};

// 矿工排序
export const MinerSortType = {
  worker_name: "worker_name",
  hashrate: "accept_15m",
  hashrate_day: "accept_24h",
  reject_rate: "reject_rate",
  last_share_time: "updated_at",
};

export const SortList = {
  descend: "desc",
  ascend: "asc",
};

// 共享费率-出块时间选择
export const blockMap = [
  { day: 30, lable: "treasury.mounth" },
  { day: 90, lable: "treasury.3mounth" },
  { day: 180, lable: "treasury.6mounth" },
  { day: 0, lable: "treasury.all" },
];
// 共享费率-资金快照时间选择
export const balanceMap = [
  { day: 7, lable: "treasury.sevenDay" },
  { day: 30, lable: "treasury.mounth" },
  { day: 90, lable: "treasury.3mounth" },
  { day: 180, lable: "treasury.6mounth" },
  { day: 0, lable: "treasury.all" },
];

// 提现方式
export const wayList = { 0: "Excel.withDraw.Manual", 1: "Excel.withDraw.Auto" };

// 图表数据源点类型
export const dotMap = { hour: "hour", day: "day" };

export enum TimeChartType {
  hour = "hour",
  day = "day",
}

export enum momentType {
  hour = "hours",
  day = "days",
  month = "months",
  year = "years",
}

export const HourMap = [
  { type: momentType.hour, value: 24, lable: "IndexCharts.24hour" },
  { type: momentType.day, value: 7, lable: "IndexCharts.7day" },
  { type: momentType.month, value: 1, lable: "IndexCharts.mounth" },
  { type: momentType.month, value: 3, lable: "IndexCharts.3mounth" },
  { type: momentType.month, value: 6, lable: "IndexCharts.6mounth" },
  { type: momentType.year, value: 1, lable: "IndexCharts.year" },
  { type: momentType.day, value: 0, lable: "IndexCharts.all" },
];

export const DayMap = [
  { type: momentType.day, value: 7, lable: "IndexCharts.7day" },
  { type: momentType.month, value: 1, lable: "IndexCharts.mounth" },
  { type: momentType.month, value: 3, lable: "IndexCharts.3mounth" },
  { type: momentType.month, value: 6, lable: "IndexCharts.6mounth" },
  { type: momentType.year, value: 1, lable: "IndexCharts.year" },
  { type: momentType.day, value: 0, lable: "IndexCharts.all" },
];

// 时间戳格式转化方法/转换时间戳格式

export enum TimeFormatType {
  Second = "Second",
  Day = "Day",
  ExportDay = "ExportDay",
  Minute = "Minute",
}

export const TimeFormatMap = {
  [TimeFormatType.Second]: DATE_TABLE_FORMAT,
  [TimeFormatType.Day]: DATE_ABLE_FORMAT_DAY,
  [TimeFormatType.ExportDay]: DATE_FORMAT_ACCURATE_TO_DAY,
  [TimeFormatType.Minute]: DATE_CHART_FORMAT,
};

export const timestampFormat = (
  timestamp: number,
  type: TimeFormatType = TimeFormatType.Second
) => {
  let time = timestamp * 1000;
  return moment(time).format(TimeFormatMap[type]);
};

export const momentFormat = (time: string, type: TimeFormatType = TimeFormatType.Second) => {
  return moment(time).format(TimeFormatMap[type]);
};

export const timeUnix = (current?: string) => {
  if (current) {
    return moment(current).unix();
  } else {
    return moment().unix();
  }
};

export const endTimeUnix = (current?: string) => {
  if (current) {
    return moment(current).endOf("day").unix();
  } else {
    return moment().endOf("day").unix();
  }
};

export const startTimeUnix = (current?: string, type: TimeChartType = TimeChartType.day) => {
  if (current) {
    return moment(current).startOf(type).unix();
  } else {
    return moment().startOf(type).unix();
  }
};

// 倒推时间
export const startTime = (value: number, currentTime: any, type: momentType = momentType.day) => {
  return moment(currentTime * 1000)
    .subtract(value, type)
    .unix();
};

// 获取当前项目的logo
export const loadImage = (file: string) => import(`@/assets/${project}/common/${file}`);

export enum RepayCoinType {
  cny = "¥",
  usdt = "$",
  bsv = "BSV",
  btc = "BTC",
  bch = "BCH",
  ltc = "LTC",
  doge = "DOGE",
}

export const coinString = (str: String, type: RepayCoinType = RepayCoinType.cny) => {
  if (type == RepayCoinType.cny || type == RepayCoinType.usdt) {
    return `${type} ${str}`;
  } else {
    return `${str} ${type}`;
  }
};

// 兑换费用类型 1 为贷款还款，2 为自缴电费，3 为代缴电费，4 运费，5 维修费，6 上架费，7 下架费，8 采购配件费，9 其他
export const chargeType = {
  1: "Loan.repayment",
  2: "Loan.self electricity",
  3: "Loan.electricity",
  4: "Loan.freight",
  5: "Loan.maintenance",
  6: "Loan.shelf",
  7: "Loan.off shelf",
  8: "Loan.purchase",
  9: "Loan.other",
};

export const setAddressType = {
  new: 1,
  asMian: 2,
  walletWeb: 3,
};

export const getAddressType = {
  1: "new",
  2: "asMian",
  3: "walletWeb",
};

export const AutoWithdrawType = {
  0: "",
  1: "noDrawing",
  2: "isConsistent",
  3: "dailyDrawing",
};

export const SetAutoWithdrawType = {
  noDrawing: 1,
  isConsistent: 2,
  dailyDrawing: 3,
};

export const ExchangeType = {
  0: "",
  1: "noExchange",
  2: "dailyExchange",
  3: "moneyExchange",
};
